import { MainPageLayoutProps } from "@components/page-layout/main-page-layout";
import Grid2 from "@mui/material/Grid2";
import { CONTENT_MAX_WIDTH, PAGE_X_MARGINS } from "@styles/common-styles";
import { PropsWithChildren } from "react";
import { Outlet } from "react-router-dom";

type Props = PropsWithChildren &
  Pick<MainPageLayoutProps, "contentBackgroundColor">;

/** The default layout of the body of sphere dashboard */
export function DefaultBodyLayout({
  contentBackgroundColor,
  children,
}: Props): JSX.Element {
  return (
    <Grid2
      container
      justifyContent="center"
      data-testid="CONTENT_WRAPPER"
      sx={{
        width: "100%",
        px: {
          xs: PAGE_X_MARGINS.xs,
          sm: PAGE_X_MARGINS.sm,
          md: PAGE_X_MARGINS.md,
          lg: PAGE_X_MARGINS.lg,
          xl: PAGE_X_MARGINS.xl,
        },
        pb: "30px",
        backgroundColor: contentBackgroundColor,
      }}
    >
      <Grid2
        data-testid="CONTENT"
        sx={{
          width: "100%",
          maxWidth: {
            xs: CONTENT_MAX_WIDTH.xs,
            sm: CONTENT_MAX_WIDTH.sm,
            md: CONTENT_MAX_WIDTH.md,
            lg: CONTENT_MAX_WIDTH.lg,
            xl: CONTENT_MAX_WIDTH.xl,
          },
        }}
      >
        {/* <Outlet> is a placeholder for the active child route defined in the routes.ts */}
        {children ? children : <Outlet />}
      </Grid2>
    </Grid2>
  );
}
